import React from 'react';


let jsonHub = {
    meta: {
        description: 'Follow the Food examines the biggest challenges facing the world food system, from climate change to malnutrition, and looks at some of the solutions to overcome them.',
        title: 'Follow the Food',
        keywords: 'bbc, corteva, follow, food',
        twitterImage: "hub_twitter_image.jpg",
        og_image: "og_image.jpg"
    },
    introduction: {
        logo: 'followthefood_logo.svg',
        carouselVideos: [

            {
            title: "Farmers on the Frontline",
            description: "From conflict to climate change, our food is under pressure like never before. Amanda Little meets farmers on three continents trying to rise to the challenge.",
            video:
                [
                    {
                        src: {
                            desktop: "episodes/follow_the_food_farmers_on_front_line-desktop.mp4",
                            tablet: "episodes/follow_the_food_farmers_on_front_line-tablet.mp4",
                            mobile: "episodes/follow_the_food_farmers_on_front_line-mobile.mp4"
                        },
                        thumbnail: {
                            episode: 'Episode 4',
                            caption: 'Farmers on the Frontline',
                            image: {
                                desktop: 'PosterImg/follow_the_food_farmers_on_front_line_Desktop.jpg',
                                tablet: 'PosterImg/follow_the_food_farmers_on_front_line_Tablet.jpg',
                                mobile: 'PosterImg/follow_the_food_farmers_on_front_line_Mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }
                ]
            ,
            ambient: {
                mobile: {
                    poster: "AmbientBG/follow_the_food_farmers_on_front_line_Mobile.jpg",
                    videoSrc: "intro/ambient/farmers_on_the_frontline-Mobile.mp4"
                },
                tablet: {
                    poster: "AmbientBG/follow_the_food_farmers_on_front_line_Tablet.jpg",
                    videoSrc: "intro/ambient/farmers_on_the_frontline-Tablet.mp4"
                },
                desktop: {
                    poster: "AmbientBG/follow_the_food_farmers_on_front_line_Desktop.jpg",
                    videoSrc: "intro/ambient/farmers_on_the_frontline-Desktop.mp4"
                }
            }
            }, 
            {
            title: "Turning back the climate clock",
            description: "Can food production help to reverse the effects of climate change and pull carbon out of the atmosphere? James Wong goes on the hunt for carbon-negative foods.",
            video:
                [
                    {
                        src: {
                            desktop: "episodes/FollowTheFood_S3_EP8_ForReel_1-desktop.mp4",
                            tablet: "episodes/FollowTheFood_S3_EP8_ForReel_1-tablet.mp4",
                            mobile: "episodes/FollowTheFood_S3_EP8_ForReel_1-mobile.mp4"
                        },
                        thumbnail: {
                            episode: 'Series 3 Episode Eight',
                            caption: 'Turning back the climate clock',
                            image: {
                                desktop: 'PosterImg/New_Series_3_Ep8_Turning_back_the_climate_clock_Desktop.jpg',
                                tablet: 'PosterImg/New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.jpg',
                                mobile: 'PosterImg/New_Series_3_Ep8_Turning_back_the_climate_clock_Mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }
                ]
            ,
            ambient: {
                mobile: {
                    poster: "AmbientBG/New_Series_3_Ep8_Turning_back_the_climate_clock_Mobile.jpg",
                    videoSrc: "intro/ambient/New_Series_3_Ep8_Turning_back_the_climate_clock_Mobile.mp4"
                },
                tablet: {
                    poster: "AmbientBG/New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.jpg",
                    videoSrc: "intro/ambient/New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.mp4"
                },
                desktop: {
                    poster: "AmbientBG/New_Series_3_Ep8_Turning_back_the_climate_clock_Desktop.jpg",
                    videoSrc: "intro/ambient/New_Series_3_Ep8_Turning_back_the_climate_clock_Desktop.mp4"
                }
            }
            }, 
            {

                title: "Food as medicine",
                description: "Food has the power to prevent and even treat diseases. James Wong meets the scientists growing new nutritious crops that could save lives.",
                video:
                    [
                        {
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP7_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP7_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP7_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Series 3 Episode Seven',
                                caption: 'Food as medicine',
                                image: {
                                    desktop: 'PosterImg/New_Series_3_Ep7_Food_as_medicine_Desktop.jpg',
                                    tablet: 'PosterImg/New_Series_3_Ep7_Food_as_medicine_Tablet.jpg',
                                    mobile: 'PosterImg/New_Series_3_Ep7_Food_as_medicine_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }
                    ]
                ,
                ambient: {
                    mobile: {
                        poster: "AmbientBG/New_Series_3_Ep7_Food_as_medicine_Mobile.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep7_Food_as_medicine_Mobile.mp4"
                    },
                    tablet: {
                        poster: "AmbientBG/New_Series_3_Ep7_Food_as_medicine_Tablet.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep7_Food_as_medicine_Tablet.mp4"
                    },
                    desktop: {
                        poster: "AmbientBG/New_Series_3_Ep7_Food_as_medicine_Desktop.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep7_Food_as_medicine_Desktop.mp4"
                    }
                }
            }, 
            {

                title: "The endangered foods list",
                description: "Important foods that we eat in our daily lives are under threat of extinction, but can they be saved?",
                video:
                    [
                        {
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP6_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP6_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP6_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Series 3 Episode Six',
                                caption: 'The endangered foods list',
                                image: {
                                    desktop: 'PosterImg/New_Series_3_Ep6_The_endangered_foods_list_Desktop.jpg',
                                    tablet: 'PosterImg/New_Series_3_Ep6_The_endangered_foods_list_Tablet.jpg',
                                    mobile: 'PosterImg/New_Series_3_Ep6_The_endangered_foods_list_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }
                    ]
                ,
                ambient: {
                    mobile: {
                        poster: "AmbientBG/New_Series_3_Ep6_The_endangered_foods_list_Mobile.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep6_The_endangered_foods_list_Mobile.mp4"
                    },
                    tablet: {
                        poster: "AmbientBG/New_Series_3_Ep6_The_endangered_foods_list_Tablet.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep6_The_endangered_foods_list_Tablet.mp4"
                    },
                    desktop: {
                        poster: "AmbientBG/New_Series_3_Ep6_The_endangered_foods_list_Desktop.jpg",
                        videoSrc: "intro/ambient/New_Series_3_Ep6_The_endangered_foods_list_Desktop.mp4"
                    }
                }
            }

        ],
        moreInSeries: {
            title: "more in this series",
            episodes: [
            {
                caption: 'Future farms',
                posterImg: 'MoreInSeries/02_Special_Ep5.jpg',
                video:
                    [
                        {
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP5_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP5_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP5_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Series 3 Episode Five',
                                caption: 'Future farms',
                                image: {
                                    desktop: 'PosterImg/New_Series_3_Ep5_Future_farms_Desktop.jpg',
                                    tablet: 'PosterImg/New_Series_3_Ep5_Future_farms_Tablet.jpg',
                                    mobile: 'PosterImg/New_Series_3_Ep5_Future_farms_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }
                    ]
            },
            {
                caption: 'Protein planet',
                posterImg: 'MoreInSeries/02_Special_Ep4.jpg',
                video:
                    [
                        {
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP4_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP4_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP4_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Series 3 Episode Four',
                                caption: 'Protein planet',
                                image: {
                                    desktop: 'PosterImg/New_Series_3_Ep4_Protein_planet_Desktop.jpg',
                                    tablet: 'PosterImg/New_Series_3_Ep4_Protein_planet_Tablet.jpg',
                                    mobile: 'PosterImg/New_Series_3_Ep4_Protein_planet_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }
                    ]
            }

            ]
        }
    },
    latestContent: {
        title: "Latest",
        HalfWidth: [
            {
                thumbnail: 'Article-summary-pic-getty.jpg',
                thumbnailTitle: "Man harvesting wheat",
                subtitle: "IN-DEPTH",
                title: "The ingredient we can't do without",
                excerpt: "",
                overlay: "true",
                externalUrl: "https://www.bbc.com/future/bespoke/follow-the-food/the-ingredient-we-cant-do-without/",
            },
            {
                thumbnail: 'The_foods_that_could_prevent_climate_disasters.jpg',
                thumbnailTitle: "Man standing up wearing a hat, with a sunset background",
                subtitle: "IN-DEPTH",
                title: "The foods that could prevent climate disasters",
                excerpt: "Modern technology is helping to reduce the impact of climate change on farming. But centuries-old practices can be powerful climate tools too. Farmers are showing that what you grow, and where you grow it, could help prevent future disasters",
                overlay: "true",
                externalUrl: "https://www.bbc.com/future/bespoke/follow-the-food/the-foods-that-could-prevent-climate-disasters/",
            }
        ]
    },
    fullWidthTitle: 'Editorial content continues below',
    seriesVideos: {
        bgImage: {
            desktop: 'Episode_Hero_Desktop.png',
            tablet: 'Episode_Hero_Tablet.png',
            mobile: 'Episode_Hero_Mobile.png'
        },
        imgTitle: 'hay bale in a field with sunset',
        overlayBgImage: "false",
        subtitle: 'Follow the Food',
        title: 'Episodes',
        description: 'These documentaries examine where our food comes from and how this might change in the near future with new technologies and innovative ways of farming.',
        shareMessage: 'Share this video',
        socialId: "seriesVideos",
        shareIconColor: 'blue',
        seriesList: [

            {
                title: 'Specials',
                isSeries: false,
                episodes: [
                    {
                        title: 'Follow the food chain',
                        isLive: true,
                        image: {
                            desktop: 'food-chains-in-peril_desktop.jpg',
                            tablet: 'food-chains-in-peril_tablet.jpg',
                            mobile: 'food-chains-in-peril_mobile.jpg'
                        },
                        imgTitle: 'guy in the field with a box of grapes',
                        video: [{
                            src: {
                                desktop: 'episodes/food-chain-special-s01-e01-desktop.mp4',
                                tablet: 'episodes/food-chain-special-s01-e01-tablet.mp4',
                                mobile: 'episodes/food-chain-special-s01-e01-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode One',
                                caption: 'Follow the food chain',
                                image: {
                                    desktop: 'food-chains-in-peril-desktop.jpg',
                                    tablet: 'food-chains-in-peril-tablet.jpg',
                                    mobile: 'food-chains-in-peril-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        social: {
                            url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                            message: "Climate change, population growth and poverty are making food supplies less secure around the world. So what can we all do to create a more resilient, flexible, sustainable and healthy food system?"
                        },

                        share: {
                            facebook: {
                                title: "How Covid-19 put our food chains in peril",
                                description: "Ensuring food is at its freshest when we buy it means supply chains operate on a knife-edge."
                            },
                            twitter: {
                                description: "Ensuring food is at its freshest when we buy it means supply chains operate on a knife-edge."
                            }
                        }
                    },
                    {
                        title: 'The fight for food security',
                        isLive: true,
                        image: {
                            desktop: 'the_fight_for_food_security_desktop.jpg',
                            tablet: 'the_fight_for_food_security_tablet.jpg',
                            mobile: 'the_fight_for_food_security_mobile.jpg'
                        },
                        imgTitle: 'Image of fields from above',
                        video: [{
                            src: {
                                desktop: 'episodes/FTF_FoodSecurity_NoCB-desktop.mp4',
                                tablet: 'episodes/FTF_FoodSecurity_NoCB-tablet.mp4',
                                mobile: 'episodes/FTF_FoodSecurity_NoCB-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Two',
                                caption: 'The fight for food security',
                                image: {
                                    desktop: 'the_fight_for_food_security-desktop.jpg',
                                    tablet: 'the_fight_for_food_security-tablet.jpg',
                                    mobile: 'the_fight_for_food_security-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        social: {
                            url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                            message: "Find out how farmers in Thailand are working together to stop the spread of a pest threatening their crops. Paid and presented by Corteva Agriscience"
                        },

                        share: {
                            facebook: {
                                title: "How Covid-19 put our food chains in peril",
                                description: "Climate change, population growth and poverty are making food supplies less secure around the world. So what can we all do to create a more resilient, flexible, sustainable and healthy food system?"
                            },
                            twitter: {
                                description: "Climate change, population growth and poverty are making food supplies less secure around the world. So what can we all do to create a more resilient, flexible, sustainable and healthy food system?"
                            }
                        }
                    },
                    {
                        title: 'The carbon challenge',
                        isLive: true,
                        image: {
                            desktop: 'the_carbon_challenge_desktop.jpg',
                            tablet: 'the_carbon_challenge_tablet.jpg',
                            mobile: 'the_carbon_challenge_mobile.jpg'
                        },
                        imgTitle: 'guy in the field with a box of grapes',
                        video: [{
                            src: {
                                desktop: 'episodes/FTF_Carbon_Reel-desktop.mp4',
                                tablet: 'episodes/FTF_Carbon_Reel-tablet.mp4',
                                mobile: 'episodes/FTF_Carbon_Reel-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Three',
                                caption: 'The carbon challenge',
                                image: {
                                    desktop: 'the_carbon_challenge-desktop.jpg',
                                    tablet: 'the_carbon_challenge-tablet.jpg',
                                    mobile: 'the_carbon_challenge-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        social: {
                            url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                            message: "Climate change, population growth and poverty are making food supplies less secure around the world. So what can we all do to create a more resilient, flexible, sustainable and healthy food system?"
                        },

                        share: {
                            facebook: {
                                title: "How Covid-19 put our food chains in peril",
                                description: "James Wong examines the relationship between food and carbon and shows how agriculture has the potential to dramatically reduce and even reverse emissions."
                            },
                            twitter: {
                                description: "James Wong examines the relationship between food and carbon and shows how agriculture has the potential to dramatically reduce and even reverse emissions."
                            }
                        }
                    },
                    {
                        title: 'Farmers on the Frontline',
                        isLive: true,
                        image: {
                            desktop: 'follow_the_food_farmers_on_front_line.jpg',
                            tablet: 'follow_the_food_farmers_on_front_line.jpg',
                            mobile: 'follow_the_food_farmers_on_front_line.jpg'
                        },
                        imgTitle: 'drone flying over a field',
                        video:
                        [
                            {
                                src: {
                                    desktop: "episodes/follow_the_food_farmers_on_front_line-desktop.mp4",
                                    tablet: "episodes/follow_the_food_farmers_on_front_line-tablet.mp4",
                                    mobile: "episodes/follow_the_food_farmers_on_front_line-mobile.mp4"
                                },
                                thumbnail: {
                                    episode: 'Episode four',
                                    caption: 'Farmers on the Frontline',
                                    image: {
                                        desktop: 'follow_the_food_farmers_on_front_line_Desktop.jpg',
                                        tablet: 'follow_the_food_farmers_on_front_line_Tablet.jpg',
                                        mobile: 'follow_the_food_farmers_on_front_line_Mobile.jpg'
                                    }
                                },
                                'ad-preroll': {
                                    'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                    keywords: ['cortevavideo']
                                }
                            }
                        ],
                        social: {
                            url: "https://www.bbc.com/reel/video/p0d9xnpl/the-fight-to-feed-humanity",
                            message: "From conflict to climate change, our food is under pressure like never before. Amanda Little meets farmers on three continents trying to rise to the challenge."
                        },

                        share: {
                            facebook: {
                                title: "Farmers on the Frontline",
                                description: "From conflict to climate change, our food is under pressure like never before. Amanda Little meets farmers on three continents trying to rise to the challenge."
                            },
                            twitter: {
                                description: "From conflict to climate change, our food is under pressure like never before. Amanda Little meets farmers on three continents trying to rise to the challenge."
                            }
                        }
                    }
                ]
            },

            {
                title: 'Series Three',
                isSeries: true,
                episodes: [
                    {
                        title: 'Foodtopia',
                        image: {
                            desktop: 'Foodtopia_desktop.jpg',
                            tablet: 'Foodtopia_tablet.jpg',
                            mobile: 'Foodtopia_mobile.jpg'
                        },
                        imgTitle: 'Tomatoes growing on a wall',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode One',
                                caption: 'Foodtopia',
                                image: {
                                    desktop: 'Foodtopia-desktop.jpg',
                                    tablet: 'Foodtopia-tablet.jpg',
                                    mobile: 'Foodtopia-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "How we might build a food utopia",
                                description: 'What would it take to reimagine the global food system so that it worked perfectly?'
                            },
                            twitter: {
                                description: 'What would it take to reimagine the global food system so that it worked perfectly?'
                            }
                        }
                    },
                    {
                        title: 'You are what your food eats',
                        image: {
                            desktop: 'New_Series_3_Ep2_You_are_what_your_food_eats_Desktop.jpg',
                            tablet: 'New_Series_3_Ep2_You_are_what_your_food_eats_Tablet.jpg',
                            mobile: 'New_Series_3_Ep2_You_are_what_your_food_eats_Mob.jpg'
                        },
                        imgTitle: 'A goat eating grass',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP2_ForReel-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP2_ForReel-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP2_ForReel-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Two',
                                caption: 'You are what your food eats',
                                image: {
                                    desktop: 'New_Series_3_Ep2_You_are_what_your_food_eats_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep2_You_are_what_your_food_eats_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep2_You_are_what_your_food_eats_Mob.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "How modern food can regain its nutrients",
                                description: 'There are concerns that in our rush to grow food on ever bigger scales, we have inadvertently caused its nutritional content to wane. What can be done to reverse that?'
                            },
                            twitter: {
                                description: 'There are concerns that in our rush to grow food on ever bigger scales, we have inadvertently caused its nutritional content to wane. What can be done to reverse that?'
                            }
                        }
                    },
                    {
                        title: 'The waste chain',
                        image: {
                            desktop: 'New_Series_3_Ep3_The_Waste_Chain_Desktop.jpg',
                            tablet: 'New_Series_3_Ep3_The_Waste_Chain_Tablet.jpg',
                            mobile: 'New_Series_3_Ep3_The_Waste_Chain_Mobile.jpg'
                        },
                        imgTitle: 'Composting tomatoes',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP3_Breakless-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP3_Breakless-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP3_Breakless-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Three',
                                caption: 'The waste chain',
                                image: {
                                    desktop: 'New_Series_3_Ep3_The_Waste_Chain_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep3_The_Waste_Chain_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep3_The_Waste_Chain_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "How to use food waste for good",
                                description: "As global food production is on the rise, food waste is soaring. About 40% of all food goes uneaten, but 10% of the world's population are hungry. This edible waste also contributes to climate change, increasing the risk of food insecurity."
                            },
                            twitter: {
                                description: "As global food production is on the rise, food waste is soaring. About 40% of all food goes uneaten, but 10% of the world's population are hungry. This edible waste also contributes to climate change, increasing the risk of food insecurity."
                            }
                        }
                    },
                    {
                        title: 'Protein planet',
                        image: {
                            desktop: 'New_Series_3_Ep4_Protein_planet_Desktop.jpg',
                            tablet: 'New_Series_3_Ep4_Protein_planet_Tablet.jpg',
                            mobile: 'New_Series_3_Ep4_Protein_planet_Mobile.jpg'
                        },
                        imgTitle: 'Straining dairy through a cloth',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP4_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP4_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP4_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Four',
                                caption: 'Protein planet',
                                image: {
                                    desktop: 'New_Series_3_Ep4_Protein_planet_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep4_Protein_planet_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep4_Protein_planet_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "The search for carbon-neutral protein ",
                                description: "A vegetarian diet might produce lower carbon emissions than meat-based foods. But non-meat animal products can have surprisingly high climate impacts. Now, some innovators are pushing to make dairy and eggs guilt-free."
                            },
                            twitter: {
                                description: "A vegetarian diet might produce lower carbon emissions than meat-based foods. But non-meat animal products can have surprisingly high climate impacts. Now, some innovators are pushing to make dairy and eggs guilt-free."
                            }
                        }
                    },
                    {
                        title: 'Future farms',
                        image: {
                            desktop: 'New_Series_3_Ep5_Future_farms_Desktop.jpg',
                            tablet: 'New_Series_3_Ep5_Future_farms_Tablet.jpg',
                            mobile: 'New_Series_3_Ep5_Future_farms_Mobile.jpg'
                        },
                        imgTitle: 'Plants growing under UV light',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP5_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP5_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP5_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Five',
                                caption: 'Future farms',
                                image: {
                                    desktop: 'New_Series_3_Ep5_Future_farms_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep5_Future_farms_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep5_Future_farms_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        },],
                        share: {
                            facebook: {
                                title: "The people building edible cities",
                                description: "By 2050, 70% of the world's population will live in urban areas. Can a new generation of farmers reduce complex and vulnerable supply chains by bringing nature back into our cities?"
                            },
                            twitter: {
                                description: "By 2050, 70% of the world's population will live in urban areas. Can a new generation of farmers reduce complex and vulnerable supply chains by bringing nature back into our cities?"
                            }
                        }
                    },
                    {
                        title: 'The endangered foods list',
                        image: {
                            desktop: 'New_Series_3_Ep6_The_endangered_foods_list_Desktop.jpg',
                            tablet: 'New_Series_3_Ep6_The_endangered_foods_list_Tablet.jpg',
                            mobile: 'New_Series_3_Ep6_The_endangered_foods_list_Mobile.jpg'
                        },
                        imgTitle: 'Important foods that we eat in our daily lives are under threat of extinction, but can they be saved?',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP6_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP6_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP6_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Six',
                                caption: 'The endangered foods lists',
                                image: {
                                    desktop: 'New_Series_3_Ep6_The_endangered_foods_list_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep6_The_endangered_foods_list_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep6_The_endangered_foods_list_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        },],
                        share: {
                            facebook: {
                                title: "Why we need to expand our crop menu",
                                description: "By 2050, 70% of the world's population will live in urban areas. Can a new generation of farmers reduce complex and vulnerable supply chains by bringing nature back into our cities?"
                            },
                            twitter: {
                                description: "By 2050, 70% of the world's population will live in urban areas. Can a new generation of farmers reduce complex and vulnerable supply chains by bringing nature back into our cities?"
                            }
                        }
                    }, {
                        title: 'Food as medicine',
                        image: {
                            desktop: 'New_Series_3_Ep7_Food_as_medicine_Desktop.jpg',
                            tablet: 'New_Series_3_Ep7_Food_as_medicine_Tablet.jpg',
                            mobile: 'New_Series_3_Ep7_Food_as_medicine_Mobile.jpg'
                        },
                        imgTitle: 'Food has the power to prevent and even treat diseases. James Wong meets the scientists growing new nutritious crops that could save lives.',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP7_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP7_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP7_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Seven',
                                caption: 'Food as medicine',
                                image: {
                                    desktop: 'New_Series_3_Ep7_Food_as_medicine_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep7_Food_as_medicine_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep7_Food_as_medicine_Mobile.jpg'

                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        },],
                        share: {
                            facebook: {
                                title: "How your diet can treat diseases",
                                description: "The food we eat is one of the leading causes of illness. As malnutrition increases, so too do the associated diseases. But can we use food to tackle the world's health problems instead?"
                            },
                            twitter: {
                                description: "The food we eat is one of the leading causes of illness. As malnutrition increases, so too do the associated diseases. But can we use food to tackle the world's health problems instead?"
                            }
                        }
                    },
                    {
                        title: 'The foods that could prevent climate disasters ',
                        image: {
                            desktop: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Desktop.jpg',
                            tablet: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.jpg',
                            mobile: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Mobile.jpg'
                        },
                        imgTitle: 'Food has the power to prevent and even treat diseases. James Wong meets the scientists growing new nutritious crops that could save lives.',
                        video: [{
                            src: {
                                desktop: "episodes/FollowTheFood_S3_EP8_ForReel_1-desktop.mp4",
                                tablet: "episodes/FollowTheFood_S3_EP8_ForReel_1-tablet.mp4",
                                mobile: "episodes/FollowTheFood_S3_EP8_ForReel_1-mobile.mp4"
                            },
                            thumbnail: {
                                episode: 'Episode Eight',
                                caption: 'Turning back the climate clock',
                                image: {
                                    desktop: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Desktop.jpg',
                                    tablet: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.jpg',
                                    mobile: 'New_Series_3_Ep8_Turning_back_the_climate_clock_Mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        },],
                        share: {
                            facebook: {
                                title: "The foods that could prevent climate disasters",
                                description: "Modern technology is helping to reduce the impact of climate change on farming. But centuries-old practices can be powerful climate tools too. Farmers are showing that what you grow, and where you grow it, could help prevent future disasters"
                            },
                            twitter: {
                                description: "Modern technology is helping to reduce the impact of climate change on farming, but centuries-old practices can be just as powerful. Farmers are showing that what you grow, and where you grow it, could help prevent future disasters"
                            }
                        }
                    }
                ]
            },

            {
                title: 'Series Two',
                isSeries: true,
                episodes: [
                    {
                        title: 'Farmers on the frontline',
                        image: {
                            desktop: 'farmer-on-the-frontline-thumbnail_desktop.jpg',
                            tablet: 'farmer-on-the-frontline-thumbnail_tablet.jpg',
                            mobile: 'farmer-on-the-frontline-thumbnail_mobile.jpg'
                        },
                        imgTitle: 'plants in polytunnel (Credit: BBC)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode1-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode1-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode1-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode One',
                                caption: 'Farmers on the frontline',
                                image: {
                                    desktop: 'Farmers-on-the-frontline-desktop.jpg',
                                    tablet: 'Farmers-on-the-frontline-tablet.jpg',
                                    mobile: 'Farmers-on-the-frontline-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "Farmers on the frontline",
                                description: 'Can farmers play a pivotal role in mitigating the environmental threats of climate change, biodiversity loss and soil degradation?'
                            },
                            twitter: {
                                description: 'Can farmers play a pivotal role in mitigating the environmental threats of climate change, biodiversity loss and soil degradation?'
                            }
                        }
                    },
                    {
                        title: 'Seeds of life',
                        image: {
                            desktop: 'seeds-of-life-thumbnail_desktop.jpg',
                            tablet: 'seeds-of-life-thumbnail_tablet.jpg',
                            mobile: 'seeds-of-life-thumbnail_mobile.jpg'
                        },
                        imgTitle: 'person holding sapling (Credit: BBC)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode2-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode2-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode2-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Two',
                                caption: 'Seeds of life',
                                image: {
                                    desktop: 'seeds-of-life-desktop.jpg',
                                    tablet: 'seeds-of-life-tablet.jpg',
                                    mobile: 'seeds-of-life-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "Seeds of life",
                                description: 'With a gene library in Svalbard and research rife globally to create crop varieties for the future, can humanity swap wheat, rice and maize for a more sustainable grass crop?'
                            },
                            twitter: {
                                description: 'With a gene library in Svalbard and research rife globally to create crop varieties for the future, can humanity swap wheat, rice and maize for a more sustainable grass crop?'
                            }
                        }
                    },
                    {
                        title: 'Growing new farmers',
                        image: {
                            desktop: 'growing_new_farmers_desktop.jpg',
                            tablet: 'growing_new_farmers_tablet.jpg',
                            mobile: 'growing_new_farmers_mobile.jpg'
                        },
                        imgTitle: 'farmer in vertical farm (Credit: BBC)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode3-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode3-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode3-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Three',
                                caption: 'Growing new farmers',
                                image: {
                                    desktop: 'growing_new_farmers_desktop.jpg',
                                    tablet: 'growing_new_farmers_tablet.jpg',
                                    mobile: 'growing_new_farmers_mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "Growing new farmers",
                                description: "The next generation of farmers are not in their farms in muddy boots, they're in engineering labs building smart harvesters and robotic weed killers."
                            },
                            twitter: {
                                description: "The next generation of farmers are not in their farms in muddy boots, they're in engineering labs building smart harvesters and robotic weed killers."
                            }
                        }
                    },
                    {
                        title: 'It never rains, it pours',
                        image: {
                            desktop: 'it-never-rains-desktop.jpg',
                            tablet: 'it-never-rains-tablet.jpg',
                            mobile: 'it-never-rains-mobile.jpg'
                        },
                        imgTitle: 'Farmer in paddy field (Credit: Getty Images)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode4-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode4-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode4-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Four',
                                caption: 'It never rains, it pours',
                                image: {
                                    desktop: 'it-never-rains-desktop.jpg',
                                    tablet: 'it-never-rains-tablet.jpg',
                                    mobile: 'it-never-rains-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "It never rains, it pours",
                                description: "The water consumption of crops is being reduced with innovative techniques that are helping to make food more sustainable."
                            },
                            twitter: {
                                description: "The water consumption of crops is being reduced with innovative techniques that are helping to make food more sustainable."
                            }
                        }
                    },
                    {
                        title: 'The promised land',
                        image: {
                            desktop: 'the-promised-land-desktop.jpg',
                            tablet: 'the-promised-land-tablet.jpg',
                            mobile: 'the-promised-land-mobile.jpg'
                        },
                        imgTitle: 'Carrots in soil (Credit: Getty Images)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode5-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode5-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode5-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Five',
                                caption: 'The promised land',
                                image: {
                                    desktop: 'the-promised-land-desktop.jpg',
                                    tablet: 'the-promised-land-tablet.jpg',
                                    mobile: 'the-promised-land-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "The promised land",
                                description: "Progressive farmers are rescuing precious top soil that takes thousands of years to form, instead of it getting eroded through mindless farming practices."
                            },
                            twitter: {
                                description: "Progressive farmers are rescuing precious top soil that takes thousands of years to form, instead of it getting eroded through mindless farming practices."
                            }
                        }
                    },
                    {
                        title: 'Urban farming',
                        image: {
                            desktop: 'urban-farming-desktop.jpg',
                            tablet: 'urban-farming-tablet.jpg',
                            mobile: 'urban-farming-mobile.jpg'
                        },
                        imgTitle: 'Carrots in soil (Credit: Getty Images)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode6-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode6-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode6-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Six',
                                caption: 'Urban farming',
                                image: {
                                    desktop: 'urban-farming-desktop.jpg',
                                    tablet: 'urban-farming-tablet.jpg',
                                    mobile: 'urban-farming-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "Urban farming",
                                description: "The concept of vertical urban farms feeding populous cities may seem ambitious, but it’s a growing reality in Paris, New York and Singapore."
                            },
                            twitter: {
                                description: "The concept of vertical urban farms feeding populous cities may seem ambitious, but it’s a growing reality in Paris, New York and Singapore."
                            }
                        }
                    },
                    {
                        title: 'A smarter harvest',
                        image: {
                            desktop: 'a-smarter-harvest-desktop.jpg',
                            tablet: 'a-smarter-harvest-tablet.jpg',
                            mobile: 'a-smarter-harvest-mobile.jpg'
                        },
                        imgTitle: 'beekeeper looking at hive (Credit: BBC)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode7-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode7-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode7-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Seven',
                                caption: 'A smarter harvest',
                                image: {
                                    desktop: 'a-smarter-harvest-desktop.jpg',
                                    tablet: 'a-smarter-harvest-tablet.jpg',
                                    mobile: 'a-smarter-harvest-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "A smarter harvest",
                                description: "There's a seismic shift underway in agriculture and chances are you will not be aware of it. Farming may be among the last industries to undergo a digital revolution. But the changes are arguably going to be further reaching than anything we've seen so far."
                            },
                            twitter: {
                                description: "There's a seismic shift underway in agriculture and chances are you will not be aware of it. Farming may be among the last industries to undergo a digital revolution. But the changes are arguably going to be further reaching than anything we've seen so far."
                            }
                        }
                    },
                    {
                        title: 'Consumer power',
                        image: {
                            desktop: 'consumer-power-desktop.jpg',
                            tablet: 'consumer-power-tablet.jpg',
                            mobile: 'consumer-power-mobile.jpg'
                        },
                        imgTitle: 'lab grown meat in a presser (Credit: BBC)',
                        video: [{
                            src: {
                                desktop: 'episodes/Reel-FollowTheFood-Series2Episode8-desktop.mp4',
                                tablet: 'episodes/Reel-FollowTheFood-Series2Episode8-tablet.mp4',
                                mobile: 'episodes/Reel-FollowTheFood-Series2Episode8-mobile.mp4'
                            },
                            thumbnail: {
                                episode: 'Episode Eight',
                                caption: 'Consumer power',
                                image: {
                                    desktop: 'consumer-power-desktop.jpg',
                                    tablet: 'consumer-power-tablet.jpg',
                                    mobile: 'consumer-power-mobile.jpg'
                                }
                            },
                            'ad-preroll': {
                                'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                                keywords: ['cortevavideo']
                            }
                        }],
                        share: {
                            facebook: {
                                title: "Consumer power",
                                description: "Food is increasingly high on the menu when it comes to climate concerns. This is how your choices can have a positive impact."
                            },
                            twitter: {
                                description: "Food is increasingly high on the menu when it comes to climate concerns. This is how your choices can have a positive impact."
                            }
                        }
                    }
                ]
            },

            {
                title: 'Series One',
                isSeries: true,
                episodes: [{
                    title: 'Closing the gap',
                    image: {
                        desktop: 'closingGap_desktop.jpg',
                        tablet: 'closingGap_tablet.png',
                        mobile: 'closingGap_mobile.jpg'
                    },
                    imgTitle: 'equipment for working the land',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e01-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e01-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e01-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode One',
                            caption: 'Closing the gap',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],

                    social: {
                        url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                        message: "Find out how farmers in Thailand are working together to stop the spread of a pest threatening their crops. Paid and presented by Corteva Agriscience"
                    },
                    share: {
                        facebook: {
                            title: "The crucial ingredient our diet lacks.",
                            description: "When we pluck produce from the shelves, we know very little about its provenance. But that could soon change."
                        },
                        twitter: {
                            description: "Changing the way we farm and employing new technologies are helping consumers understand the provenance of their food."
                        }
                    }
                }, {
                    title: 'The water challenge',
                    image: {
                        desktop: '04_hero_desktop.jpg',
                        tablet: '04_hero_tablet.jpg',
                        mobile: '04_hero_mobile.jpg'
                    },
                    imgTitle: 'water splashing in a field',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e02-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e02-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e02-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Two',
                            caption: 'The water challenge',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],

                    social: {
                        url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                        message: "Find out how farmers in Thailand are working together to stop the spread of a pest threatening their crops. Paid and presented by Corteva Agriscience"
                    },
                    share: {
                        facebook: {
                            title: "A staple food to withstand disaster",
                            description: "Agriculture accounts for 70% of the world’s freshwater use. But we’re running out of water, and the population is growing. What is the solution?"
                        },
                        twitter: {
                            description: "The world’s crops need 2.7 trillion cubic metres of water a year. How can we meet the growing shortage?"
                        }
                    }
                }, {
                    title: 'Generation Farmer',
                    image: {
                        desktop: '06_hero_desktop.jpg',
                        tablet: '06_hero_tablet.jpg',
                        mobile: '06_hero_mobile.jpg'
                    },
                    imgTitle: 'people gathering vegetables in a field',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e03-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e03-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e03-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Three',
                            caption: 'Generation Farmer',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "The ageing crisis threating farming",
                            description: "Young people are increasingly choosing city life. Who will grow our food?"
                        },
                        twitter: {
                            description: "In the UK, the average age of a farmer is 59. In Kenya, it is 60. And in Japan, which has the highest average age for a farmer, it is 67."
                        }
                    }
                }, {
                    title: 'Hi-tech solutions',
                    image: {
                        desktop: '07_hero_desktop.jpg',
                        tablet: '07_hero_tablet.jpg',
                        mobile: '07_hero_mobile.jpg'
                    },
                    imgTitle: 'Hi-tech equipment',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e04-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e04-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e04-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Four',
                            caption: 'Hi-tech solutions',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "The robots putting food on the table",
                            description: "Could Tom, the autonomous robotic farming assistant, be the future of farming?"
                        },
                        twitter: {
                            description: "Robots: the new agricultural revolutionaries?"
                        }
                    }
                }, {
                    title: 'Wasting waste',
                    image: {
                        desktop: '08_hero_desktop.jpg',
                        tablet: '08_hero_tablet.jpg',
                        mobile: '08_hero_mobile.jpg'
                    },
                    imgTitle: 'red sweet chillis',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e05-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e05-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e05-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Five',
                            caption: 'Wasting waste',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "The wasteful fate of a third of food",
                            description: "One third of all food produced is wasted, either before or during harvest."
                        },
                        twitter: {
                            description: "We could feed millions more people without producing any more food than we already do."
                        }
                    }
                }, {
                    title: 'Better food',
                    image: {
                        desktop: '10_hero_desktop.jpg',
                        tablet: '10_hero_tablet.jpg',
                        mobile: '10_hero_mobile.jpg'
                    },
                    imgTitle: 'people in a green market',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e06-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e06-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e06-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Six',
                            caption: 'Better food',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "The hidden hunger afffecting billions",
                            description: "One third of all food produced is wasted, either before or during harvest."
                        },
                        twitter: {
                            description: "We could feed millions more people without producing any more food than we already do."
                        }
                    }
                }, {
                    title: 'Soil: The new gold rush',
                    image: {
                        desktop: '11b_hero_desktop.jpg',
                        tablet: '11b_hero_tablet.jpg',
                        mobile: '11b_hero_mobile.jpg'
                    },
                    imgTitle: 'legs of a farmer in a dusty field',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e07-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e07-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e07-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Seven',
                            caption: 'Soil: The new gold rush',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "Why soil is disappearing from farms",
                            description: "Without sufficient soil, our ability to grow food is threatened."
                        },
                        twitter: {
                            description: "A combination of natural change and intensive farming practices is degrading our soils worldwide."
                        }
                    }
                }, {
                    title: 'Sustainable food systems',
                    image: {
                        desktop: 'sustainable_desktop.jpg',
                        tablet: 'sustainable_tablet.jpg',
                        mobile: 'sustainable_mobile.jpg'
                    },
                    imgTitle: 'food systems in floors',
                    video: [{
                        src: {
                            desktop: 'episodes/follow-the-food-s01e08-desktop.mp4',
                            tablet: 'episodes/follow-the-food-s01e08-tablet.mp4',
                            mobile: 'episodes/follow-the-food-s01e08-mobile.mp4'
                        },
                        thumbnail: {
                            episode: 'Episode Eight',
                            caption: 'Sustainable food systems',
                            image: {
                                desktop: 'series-poster-desktop.jpg',
                                tablet: 'series-poster-tablet.jpg',
                                mobile: 'series-poster-mobile.jpg'
                            }
                        },
                        'ad-preroll': {
                            'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/4817/bbccom.live.site.future&ciu_szs=640x360&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcortevavideo&correlator=',
                            keywords: ['cortevavideo']
                        }
                    }],
                    share: {
                        facebook: {
                            title: "The clean farming revolution",
                            description: "There are few human activities that have changed the world’s landscapes and environment more than farming."
                        },
                        twitter: {
                            description: "Is it possible to protect crops without harming the wider environment?"
                        }
                    }
                }],
            }

        ]
    },
    advert: {
        billboard: 'bbccom.live.site.specialfeatures',
        leaderboard: 'bbccom.live.site.specialfeatures',
        mobile: 'bbccom.live.site.specialfeatures',
        columns: ["corteva", "corteva2"]
    },
    sponsoredVideos: {
        heading: "More from this advertiser",
        shareMessage: "Share this video",
        socialId: "sponsoredVideos",
        videoList: [
            {
                title: "Cracking the code",
                bodyCopy: "What can crops do besides feed us? To understand a crop's true potential, we have to understand the plant at a genomic level. See how Corteva Agriscience and PepsiCo teamed up to unlock the potential of oats to be better for farmers, consumers and the planet.",
                social: {
                    url: "https://www.bbc.com/future/bespoke/follow-the-food/",
                    message: "See how Corteva Agriscience and PepsiCo teamed up to unlock the potential of oats to be better for farmers, consumers and the planet. Paid and presented by Corteva Agriscience"
                },
                thumbnailImage: "cracking-the-code.jpg",
                imageTitle: "Scientist in lab",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT021-120_no_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT021-120_no_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT021-120_no_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'cracking-the-code-desktop.jpg',
                            tablet: 'cracking-the-code-tablet.jpg',
                            mobile: 'cracking-the-code-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Seeds of change",
                bodyCopy: "For thousands of years rice has been grown in flooded paddies. Not only does this method use a lot of water, it produces enormous quantities of methane. See how Corteva is helping one family in India grow rice a new way, saving water, methane emissions and money.",
                social: {
                    url: "https://www.bbc.com/future/bespoke/follow-the-food/",
                    message: "Forward-thinking rice farmers in India have recognised the benefits of a farming technique that reduces water consumption, methane emissions and soil erosion. Paid and presented by Corteva Agriscience"
                },
                thumbnailImage: "seeds-of-change-desktop.jpg",
                imageTitle: "Person harvesting rise in paddy field ",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT020-120_without_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT020-120_without_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT020-120_without_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'seeds-of-change-desktop.jpg',
                            tablet: 'seeds-of-change-tablet.jpg',
                            mobile: 'seeds-of-change-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Transforming the farm",
                bodyCopy: "Corteva Agriscience aims to disrupt the entire agriculture industry - and themselves. Through innovative projects that help solve problems farmers don’t even know they have yet, Corteva is at the forefront of creating technology that’s pushing agriculture forward.",
                social: {
                    url: "https://www.bbc.com/future/bespoke/follow-the-food/",
                    message: "Unleashing the future of agriculture through robotics, satellite imagery and plant fingerprinting."
                },
                thumbnailImage: "silicon-farm-thumbnail.jpg",
                imageTitle: "Two men inspecting bee hive",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT015-120_without_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT015-120_without_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT015-120_without_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'silicon-farm-poster-desktop.jpg',
                            tablet: 'silicon-farm-poster-tablet.jpg',
                            mobile: 'silicon-farm-poster-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "From data to decision",
                bodyCopy: " Farms don’t just yield crops, they yield data. And with new information coming in all the time, Corteva Agriscience helps farmers turn that data into insights so they can unlock answers across the farm.",
                social: {
                    url: "https://www.bbc.com/future/bespoke/follow-the-food/",
                    message: "Farms don’t just yield crops, they yield data that assist farmers to enhance their operations and production."
                },
                thumbnailImage: "Corteva_From_Data_to_Decision.jpg",
                imageTitle: "Combine harvester in field",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT017-060_no_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT017-060_no_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT017-060_no_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Corteva_From_Data_to_Decision-desktop.jpg',
                            tablet: 'Corteva_From_Data_to_Decision-tablet.jpg',
                            mobile: 'Corteva_From_Data_to_Decision-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Do more with less",
                bodyCopy: "Farmers are under increasing pressure to produce more while working with fewer resources. Corteva Agriscience provides the resources to help them see more, know more, and do more with less.",
                social: {
                    url: "https://www.bbc.com/future/bespoke/follow-the-food/",
                    message: "Farmers can now see more, learn more, do more and achieve more for less for every acre of agricultural land."
                },
                thumbnailImage: "Corteva_Do_More_with_Less.jpg",
                imageTitle: "Text in clouds",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT018-060_no_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT018-060_no_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT018-060_no_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Corteva_Do_More_with_Less-desktop.jpg',
                            tablet: 'Corteva_Do_More_with_Less-tablet.jpg',
                            mobile: 'Corteva_Do_More_with_Less-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Securing food security",
                bodyCopy: 'The fall armyworm, a caterpillar known for moving like an "army", can destroy a corn field in a matter of days. Native to tropical regions of the western hemisphere, the fall armyworm has now made its way across the globe to Asia. In Thailand, the government acted fast and worked with Corteva Agriscience, to provide farmers with preventative measures and solutions. See how Corteva’s knowledge in crop biotechnology and experience from around the world is supporting Thailand farmers and securing food security.',

                social: {

                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p08bxd52",
                    message: "How bio-technological know-how is supporting Thailand’s farmers and securing food security?"
                },
                thumbnailImage: "Thailand.jpg",
                imageTitle: "local farme in a field",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT013-120_NO_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT013-120_NO_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT013-120_NO_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Thailand-desktop.jpg',
                            tablet: 'Thailand-tablet.jpg',
                            mobile: 'Thailand-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Farming for the future",
                bodyCopy: "Queen is a Tanzanian farmer from a farming family. Queen’s income means she can pay for her children’s education and the foundation of a good life. See how Corteva Agriscience is collaborating with partners like USAID to help smallholder farmers across Tanzania improve their yields and their communities.",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p085rvg7",
                    message: "“If one farmer improves their economic state, then the entire country’s economy improves.” Find out how quality seeds and training have changed this farmer’s life. Paid and presented by Corteva Agriscience"
                },
                thumbnailImage: "Tanzania-Queen-and-Son-small.jpg",
                imageTitle: "local farme in a field",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT012-120_without_advertisment-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT012-120_without_advertisment-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT012-120_without_advertisment-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Tanzania-Queen-and-Son-small-desktop.jpg',
                            tablet: 'Tanzania-Queen-and-Son-small-tablet.jpg',
                            mobile: 'Tanzania-Queen-and-Son-small-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "How the world grows",
                bodyCopy: "With a global workforce of over 20,000 people, Corteva AgriscienceTM has some of the smartest minds in ag working so farmers can Keep Growing. Meet one of them: Jillian Foerster, who leads projects that tackle diseases like Asian Soybean Rust.",
                thumbnailImage: "howTheWorldGrow-desktop.jpg",
                imageTitle: "scientist give water to a plant",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p07g37xc",
                    message: "How one company is making sure 10 billion people can eat. Paid and presented by Corteva Agriscience"
                },
                video: [{
                    src: {
                        desktop: 'sponsored/CORTEVA_FILM_2_IOWA_How_the_world_grows_no_advert_supers-desktop.mp4',
                        tablet: 'sponsored/CORTEVA_FILM_2_IOWA_How_the_world_grows_no_advert_supers-tablet.mp4',
                        mobile: 'sponsored/CORTEVA_FILM_2_IOWA_How_the_world_grows_no_advert_supers-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg',
                            tablet: 'Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg',
                            mobile: 'Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Farming where it doesn't rain",
                bodyCopy: "100 meters underground, and then uses data analysis supplied by his Corteva AgriscienceTM rep to irrigate his crops efficiently and sustainably. See how Corteva AgriscienceTM helps Ramón Keep Growing in arid Albacete, Spain.",
                thumbnailImage: "farmingWithNoRain-desktop.jpg",
                imageTitle: "landscape of field irrigation",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p07g37tp",
                    message: "See how data helps farmers grow where it doesn't rain. Paid and presented by Corteva Agriscience"
                },
                video: [{
                    src: {
                        desktop: 'sponsored/CORTEVA_FILM_1_SPAIN_Farming_where_it_doesnt_rain_no_advert_supers-desktop.mp4',
                        tablet: 'sponsored/CORTEVA_FILM_1_SPAIN_Farming_where_it_doesnt_rain_no_advert_supers-tablet.mp4',
                        mobile: 'sponsored/CORTEVA_FILM_1_SPAIN_Farming_where_it_doesnt_rain_no_advert_supers-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'Farming_where_it_doesnt_rain_tablet.png',
                            tablet: 'Farming_where_it_doesnt_rain_tablet.png',
                            mobile: 'Farming_where_it_doesnt_rain_tablet.png'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "The art of precision",
                bodyCopy: "The Halcombs practice precision farming to plant the right seed in the right acre, get the most out of their land, farm sustainably, and spot issues before they become problems. See how Corteva AgriscienceTM helps the Halcombs farm from the sky.",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p07g37z5",
                    message: "See how technology on the farm helps farmers do more with less. Paid and Presented by Corteva Agriscience."
                },
                thumbnailImage: "artOfPrecision-desktop.jpg",
                imageTitle: "tracktor in a field",
                video: [{
                    src: {
                        desktop: 'sponsored/CORTEVA_FILM_3_KENTUCKY_The_art_of_precision_no_advert_supers-desktop.mp4',
                        tablet: 'sponsored/CORTEVA_FILM_3_KENTUCKY_The_art_of_precision_no_advert_supers-tablet.mp4',
                        mobile: 'sponsored/CORTEVA_FILM_3_KENTUCKY_The_art_of_precision_no_advert_supers-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'art-of-precision.jpg',
                            tablet: 'art-of-precision.jpg',
                            mobile: 'art-of-precision.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Turning old pastures new",
                bodyCopy: "The Recanto Ranch in Brazil is emblematic of a global conundrum: How do you satisfy a growing appetite for beef without expanding your ranchland into surrounding forests? See how Corteva Agrisicence™ helps this family preserve their precious land.",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p07t7zbx",
                    message: "See how pastures in Brazil are lending towards increased food supply, while preserving nature's balance. Paid and presented by Corteva Agriscience"
                },
                thumbnailImage: "brazil_old_pastures.jpg",
                imageTitle: "farmer on a horse with sheeps",
                video: [{
                    src: {
                        desktop: 'sponsored/TMT-CORT011-120_under_50mb_no_advertisement-desktop.mp4',
                        tablet: 'sponsored/TMT-CORT011-120_under_50mb_no_advertisement-tablet.mp4',
                        mobile: 'sponsored/TMT-CORT011-120_under_50mb_no_advertisement-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'brasil_new_pastures-desktop.jpg',
                            tablet: 'brasil_new_pastures-tablet.jpg',
                            mobile: 'brasil_new_pastures-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            },
            {
                title: "Food by prescription",
                bodyCopy: "In Kakamega, Kenya, farmers like Edith Adembesa are no longer farming to feed themselves, but to support themselves. Working with AMPATH and the Kenyan government, Corteva is helping an entire nation grow more nutritious food—and gain a higher standard of living.",
                social: {
                    url: "https://www.bbc.com/reel/playlist/follow-the-food?vpid=p07gbt1s",
                    message: "What happens when a doctor prescribes food? Paid and presented by Corteva Agriscience"
                },
                thumbnailImage: "foodByPrescription-desktop.jpg",
                imageTitle: "seeds in hands",
                video: [{
                    src: {
                        desktop: 'sponsored/CORTEVA_FILM_4_KENYA_Food_by_prescription_no_advert_supers-desktop.mp4',
                        tablet: 'sponsored/CORTEVA_FILM_4_KENYA_Food_by_prescription_no_advert_supers-tablet.mp4',
                        mobile: 'sponsored/CORTEVA_FILM_4_KENYA_Food_by_prescription_no_advert_supers-mobile.mp4'
                    },
                    thumbnail: {
                        caption: '',
                        image: {
                            desktop: 'TMT-CORT010-120-desktop.jpg',
                            tablet: 'TMT-CORT010-120-tablet.jpg',
                            mobile: 'TMT-CORT010-120-mobile.jpg'
                        }
                    },
                    offline: {
                        title: 'Oh no! :(',
                        subtitle: 'It seems that you’re offline, refresh below to watch the video.'
                    },
                    'ad-preroll': {
                        'ad-tag': 'https://pubads.g.doubleclick.net/gampad/ads?sz=512x288&iu=/4817/bbccom.live.site.future&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=column%3Dcorteva&correlator=',
                        keywords: ['corteva']
                    }
                }]
            }

        ]
    },
    InDepth: {
        subtitle: "FOLLOW THE FOOD",
        title: "In-Depth",
        description: "An in-depth multimedia series examining the biggest pressures on the world food system, from soil loss to malnutrition, and the solutions to help overcome them.",
        bgImage: {
            desktop: 'In_Depth_Hero_Desktop.png',
            tablet: 'In_Depth_Hero_Mobile.png',
            mobile: 'In_Depth_Hero_Tablet.png'
        },
        imgTitle: 'people who collect crops',
        overlayBgImage: "false",

        series_one: [
            {
                title: 'The crucial ingredient our diet lacks',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-crucial-ingredient-our-diet-lacks/',
                image: 'crucial-ingredient.jpg',
                imageTitle: 'oranges on a conveyor belt'
            },
            {
                title: 'A staple food to withstand disaster',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/a-staple-food-to-withstand-disaster/',
                darken: true,
                image: 'a-staple-food-withstand-disaster.jpg',
                imageTitle: 'tracktor in a dusty field'
            },
            {
                title: 'The ageing crisis threatening farming',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-ageing-crisis-threatening-farming/',
                image: 'ageing-crisis.jpg',
                imageTitle: 'farmer checking a fruit plant'

            },
            {
                title: 'The robots putting food on the table',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-robots-putting-food-on-the-table/',
                image: 'the-robots-putting-food-on-the-table.jpg',
                imageTitle: 'robot that cut grass in action'

            },
            {
                title: 'The wasteful fate of a third of food',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-wasteful-fate-of-a-third-of-food/',
                image: 'the-wasteful-fate-of-a-third-of-food.jpg',
                imageTitle: 'tracktor in a field of garbages'
            },
            {
                title: 'The hidden hunger affecting billions',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-hidden-hunger-affecting-billions/',
                image: 'the-hidden-hunger-affectiong-billions.jpg',
                imageTitle: 'slices of bread'

            },
            {
                title: 'Why soil is disappearing from farms',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/why-soil-is-disappearing-from-farms/',
                image: 'why-soil-is-dissappearing-from-our-farms.jpg',
                imageTitle: 'farmer boot in a dusty field'

            },
            {
                title: 'The clean farming revolution',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-clean-farming-revolution/',
                image: 'vertical_farm.jpg',
                imageTitle: 'food systems in floors'
            }
        ],
        series_two: [
            {
                title: "How to cut your food's carbon footprint",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-to-cut-your-foods-carbon-footprint/',
                darken: false,
                image: 'how-to-cut-your-foods-carbon-footprint.jpg',
                imageTitle: 'Person shopping for fresh organic groceries in supermarket (Credit: Getty Images)'

            },
            {
                title: 'The foods that reverse climate change',
                url: 'http://www.bbc.com/future/bespoke/follow-the-food/the-foods-that-reverse-climate-change/',
                darken: false,
                image: 'GettyImages-1061685670_crop.jpg',
                imageTitle: 'The clean farming revolution'

            },
            {
                title: 'Why we need to expand our diet',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-forgotten-plants-that-could-excite-our-tastebuds/',
                darken: false,
                image: 'seeds-of-life.jpg',
                imageTitle: 'Women in Burkina Faso collecting moringa leaves (Credit: Mike Goldwater/Alamy)'

            },
            {
                title: 'The reason we’re running out of farmers',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-reason-we-are-running-out-of-farmers/',
                darken: false,
                image: 'growing-new-farmers.jpg',
                imageTitle: 'An older farmer pauses for a break (Credit: Getty Images)'

            },
            {
                title: 'Why our food needs to use less water',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/why-our-food-needs-to-use-less-water/',
                darken: false,
                image: 'it-never-rains.jpg',
                imageTitle: 'An arial view of a parched cattle ranch (Credit: Getty Images)'

            },
            {
                title: 'How to bring life to dying soils',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-to-bring-life-to-dying-soils/',
                darken: false,
                image: 'the-promised-land.jpg',
                imageTitle: 'Close-Up Of Man Holding Soil (Credit: Jason Rogers/Getty Images)'

            },
            {
                title: 'How to grow food in a concrete jungle',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-to-grow-food-in-a-concrete-jungle/',
                darken: false,
                image: 'urban-farming.jpg',
                imageTitle: 'Julie Flickner inspects kale at 80 Acres Farm in Cincinnati, OH (Credit: Maddie McGarvey/Getty Images)'

            },
            {
                title: 'The farms being run from space',
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-farms-being-run-from-space/',
                darken: false,
                image: 'the-farms-being-run-from-space.jpg',
                imageTitle: 'Weather Satellite orbiting Earth (Credit: Getty Images)'

            }
        ],
        series_three: [
            {
                title: "How we might build a food utopia",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-we-might-build-a-food-utopia/',
                darken: false,
                image: 'how-we-might-build-a-food-utopia.jpg',
                imageTitle: 'A person cooking street food'

            },
            {
                title: "You are what your food eats",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/why-modern-food-lost-its-nutrients/',
                darken: false,
                image: 'you-are-what-your-food-eats.jpg',
                imageTitle: 'A person shopping for vegetables at a market'

            },
            {
                title: "How to use food waste for good",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-to-use-food-waste-for-good/',
                darken: false,
                image: 'how-to-use-food-waste-for-good.jpg',
                imageTitle: 'Food waste composting'

            },
            {
                title: "The search for carbon-neutral protein",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-search-for-carbon-neutral-protein/',
                darken: false,
                image: 'the-search-for-carbon-neutral-protein.jpg',
                imageTitle: 'Cows in a shed'

            },
            {
                title: "The people building edible cities",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-people-building-edible-cities/',
                darken: false,
                image: 'the-people-building-edible-cities.jpg',
                imageTitle: 'Airel view of a farm on a rooftop'

            },
            {
                title: "Why we need to expand our crop menu",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/why-we-need-to-expand-our-crop-menu/',
                darken: false,
                image: 'Why-we-need-to-expand-our-crop-menu.jpg',
                imageTitle: 'women in a farm'

            }, {
                title: "How your diet can treat diseases",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-your-diet-can-treat-diseases/',
                darken: false,
                image: 'How_your_diet_can_treat_diseases.jpg',
                imageTitle: 'People having fun whilst carrying food'

            }
            , {
                title: "The foods that could prevent climate disasters",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-foods-that-could-prevent-climate-disasters/',
                darken: false,
                image: 'The_foods_that_could_prevent_climate_disasters.jpg',
                imageTitle: 'Man standing up wearing a hat, with a sunset background'

            }

        ],
        specials: [
            {
                title: "The race to improve food security",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-race-to-improve-food-security/',
                darken: false,
                image: 'the-race-to-improve-food-security.jpg',
                imageTitle: 'People await for a food distribution organized by international humanitarian organizations World Food Programme (WFP) and World Vision in Simumbwe.'

            },
            {
                title: "How a 'transfarmation' can help the climate",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-a-transfarmation-can-help-the-climate/',
                darken: false,
                image: 'how-a-transfarmation-can-help-the-climate.jpg',
                imageTitle: 'Cows grazing in a field'

            },
            {

                title: "How Covid-19 has reshaped the food chain",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/how-covid-19-has-reshaped-the-food-chain.html',
                darken: false,
                image: 'food-chain-thumbnail-article.jpg',
                imageTitle: 'Groceries drivers with boxes full of fruits'
            },
            { 

                title: "The ingredient we can't do without",
                url: 'https://www.bbc.com/future/bespoke/follow-the-food/the-ingredient-we-cant-do-without/',
                darken: false,
                image: 'follow_the_food_farmers_on_front_line.jpg',
                imageTitle: 'Man harvesting wheat'
            }
        ]

    },
    articles: {
        subtitle: 'Follow the food',
        title: 'Articles',
        description: "Insights from farmers, researchers and industry experts who are working to bolster food security so the world can feed its growing population while also tackling the challenges it faces.",
        bgImage: {
            desktop: 'Articles_Hero_Desktop.png',
            tablet: 'Articles_Hero_Tablet.png',
            mobile: 'Articles_Hero_Mobile.png'
        },
        overlayBgImage: "false",
        articles: [
            {
                image: "how-we-can-adapt-plants-to-save-our-planet-thumbnail.jpg",
                imgTitle: "Two plants in petri dishes (Credit: Getty Images)",
                title: "How we can adapt plants to save our planet",
                url: "/how-we-can-adapt-plants-to-save-our-planet.html"
            },
            {
                image: "GettyImages-1229380660_thumbnail.jpg",
                imgTitle: "Women sort grain from chaff (Credit: Getty Images)",
                title: "The reasons to be hopeful our food will fix the planet",
                url: "/how-our-food-can-fix-the-planet.html"
            },
            {
                image: "GettyImages-683364764_crop.jpg",
                imgTitle: "A farmer watches his sugar cane burn (Credit: Getty Images)",
                title: "How to feed the world in the next crisis",
                url: "/how-to-feed-the-world-in-the-next-crisis.html"
            },
            {
                image: "aerial.jpg",
                imgTitle: "A rancher rides out looking for cattle (Credit: Getty Images)",
                title: "The drones watching over cattle where cowboys cannot",
                url: "/drones-finding-cattle-where-cowboys-cannot-reach.html"
            },

            {
                image: "the-simple-shellfish-that-fights-climate-change-thumbnail.jpg",
                imgTitle: "Fishman on a boat in the see",
                title: "The simple food that fights climate change",
                url: "/the-simple-shellfish-that-fights-climate-change.html"
            },

            {
                image: "LNC-aggregates-on-sand-2-crop.jpg",
                imgTitle: "Particles under a microscope",
                title: "The spray that turns deserts into farmland",
                url: "/the-spray-that-turns-deserts-into-farmland.html"
            },
            {
                image: "the-green-milk-made-from-cells.jpg",
                imgTitle: "Doctor doses milk into test tube",
                title: 'The "green" milk made from cells',
                url: "/the-green-milk-made-from-cells.html"
            },
            {
                image: "Seawatergreenhouseaus_crop.jpg",
                imgTitle: "Farm view from distance",
                title: "The farm that doesn't need freshwater",
                url: "/the-people-creating-an-oasis-with-seawater.html"
            },
            {
                image: "2ATH3BK.crop.jpg",
                imgTitle: "People checking fishes in a market",
                title: "The digital port that was prepared for Covid",
                url: "/the-digital-port-that-was-prepared-for-covid.html"
            },
            {
                image: "ABENT3.crop_thumb.jpg",
                imgTitle: "Farmer cutting bananas",
                title: 'The "pandemic" threatening bananas',
                url: "/the-pandemic-threatening-bananas.html"
            },
            {
                image: "how-covid-19-is-changing-food-shopping.jpg",
                imgTitle: "Delivery guy on the footstep of a house, delivering grocery",
                title: "How Covid-19 is changing food shopping",
                url: "/how-covid-19-is-changing-food-shopping.html"
            },
            {
                image: "africa_getty.jpg",
                imgTitle: "Farmers planting seeds",
                title: 'The "lost" seeds helping to feed a nation',
                url: "/the-lost-seeds-helping-to-feed-a-nation.html"
            },
            {
                title: 'The robots that can pick kiwi-fruit',
                url: '/the-robots-that-can-pick-kiwifruit.html',
                imgTitle: "Robots picking up kiwi-fruit",
                image: 'kiwi-picker-robotics.jpg'
            },
            {
                title: 'The city switching to local produce',
                url: '/the-city-switching-to-local-produce.html',
                imgTitle: "Smiling guy",
                image: 'the-freedom-soup-saving-a-city.jpg'
            },
            {
                title: 'The farms appearing beneath our cities',
                url: '/the-massive-farms-emerging-beneath-our-cities.html',
                imgTitle: "Farmers planting plants",
                image: 'the-massive-farms-emerging-beneath-our-cities.jpg'
            },
            {
                title: 'The urban farm sending meals to children',
                url: '/the-urban-farm-sending-meals-to-children.html',
                imgTitle: "People putting vegetables in boxes",
                image: 'the-urban-farm-sending-meals-to-children.jpg'
            },

            {
                title: "The miller delivering flour to people's homes",
                url: '/the-miller-sending-flour-to-peoples-home.html',
                imgTitle: "Smiling man with sunglasses in front of a flour factory",
                image: 'The_miller_delivering_flour_to_people_homes.jpg'
            },
            {
                title: 'The food workers producing miracles in a crisis',
                url: '/the-food-workers-producing-miracles-in-a-crisis.html',
                imgTitle: "A farmer collecting fruits",
                image: 'miracles_in_a_crisis.jpg'
            },
            {
                title: 'The green sludge that could transform our diets',
                url: '/the-green-sludge-that-could-transform-our-diets.html',
                imgTitle: "Particles in the microscope",
                image: 'how_algae_could_transform_diets_article.jpg'
            },
            {
                title: 'The "invisible" women at the heart of the chocolate industry',
                url: '/the-invisible-women-farmers-of-ivory-coast.html',
                imgTitle: "Woman farmer rolling chocolate with a glass bottle",
                image: 'the_invisible_women_article.jpg'
            },
            {
                title: 'Can we save the bees that feed the world',
                url: '/the-travelling-bees-farms-that-feeds-us.html',
                imgTitle: "Delivery van passing in a field of yellow flowers",
                image: 'save_the_bees_article.jpg'
            }, {
                title: 'How farming in forests could sustain the planet',
                url: '/how-farming-in-forests-could-sustain-the-planet.html',
                imgTitle: "Deep forest view",
                image: 'farming-in-forests-article.jpg'
            }, {
                title: 'Why food\'s plastic problem is bigger than we realise',
                url: '/why-foods-plastic-problem-is-bigger-than-we-realise.html',
                imgTitle: "Little plants pot",
                image: 'plastic-problem-article.jpg'
            }, {
                title: 'How farming can help to heal nature',
                url: '/how-farming-can-help-to-heal-nature.html',
                imgTitle: "Forest destroied",
                image: '03_thumbnail.jpg'
            }, {
                title: 'How to fix our broken food system',
                url: '/how-to-fix-our-broken-food-system.html',
                imgTitle: "Farmer working on chickpeas",
                image: '01_thumbnail.jpg'
            }, {
                title: 'Five ways we can feed the world in 2050',
                url: '/five-ways-we-can-feed-the-world-in-2050.html',
                imgTitle: "Drone flying on a field",
                image: '02_thumbnail.jpg'
            }
        ]
    },
    share: {
        titleSmall: "Find out more",
        title: 'Message us via',
        facebookMessage: "How is agriculture responding to the challenges of climate change, environmental degradation, growing populations and the Covid-19 pandemic? BBC Future investigates",
        twitter: {
            message: "How is agriculture responding to the challenges of climate change, environmental degradation, growing populations and the Covid-19 pandemic? BBC Future investigates",
            via: "BBC_Future"
        },
        mailLink: "mailto:test@bbc.com"

    },
    footerImage: [{
        image: {
            desktop: 'Footer-Desktop.jpg',
            tablet: 'Footer-Tablet.jpg',
            mobile: 'Footer-Mobile.jpg'
        }
    }],
}

export default jsonHub;